import { useCallback } from 'react';
import { useFormService, FORM_EVENTS } from '@bingads-webui-react/form';
import { useBackToOverview } from './use-back-to-overview';


export const useSettingsFormAction = ({ siteMap }) => {
  const { send } = useFormService();

  const { backToOverviewPage } = useBackToOverview({ siteMap });
  // const [isSaving, setIsSaving] = useState(false);
  // const { save } = repository();
  const onClickSaveButton = useCallback(() => {
    send(FORM_EVENTS.SAVE);
  }, [send]);

  return {
    onClickBackButton: backToOverviewPage,
    onClickSaveButton,
  };
};
